import { render, staticRenderFns } from "./CommunityElderByGender.vue?vue&type=template&id=3b4f10d0&scoped=true&"
import script from "./CommunityElderByGender.vue?vue&type=script&lang=js&"
export * from "./CommunityElderByGender.vue?vue&type=script&lang=js&"
import style0 from "./CommunityElderByGender.vue?vue&type=style&index=0&id=3b4f10d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4f10d0",
  null
  
)

export default component.exports